import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface ViewAllButtonProps {
  onClick?: () => void;
  label?: string;
  sortType: "newest" | "popular" | "on_sale" | "featured";
  path: string;
}

const ViewAllButton: React.FC<ViewAllButtonProps> = ({
  onClick,
  label,
  sortType,
  path,
}) => {
  const getButtonStyles = () => {
    switch (sortType) {
      case "on_sale":
        return "bg-red-500 hover:bg-red-600 text-white";
      case "newest":
        return "bg-emerald-500 hover:bg-emerald-600 text-white";
      case "popular":
        return "bg-purple-600 hover:bg-purple-700 text-white";
      case "featured":
        return "bg-yellow-500 hover:bg-yellow-600 text-white";
      default:
        return "bg-gray-800 hover:bg-gray-900 text-white";
    }
  };

  const getDefaultLabel = () => {
    switch (sortType) {
      case "on_sale":
        return "View All Sales";
      case "newest":
        return "View All New";
      case "popular":
        return "View All Popular";
      case "featured":
        return "View All Featured";
      default:
        return "View All";
    }
  };

  const buttonStyles = getButtonStyles();

  return (
    <div className="flex justify-center">
      <Link to={path} onClick={onClick} className="group">
        <button
          className={`
            ${buttonStyles}
            px-5 py-2.5 rounded-lg font-medium text-sm
            transition-all duration-200
            shadow-sm hover:shadow-md
            transform hover:-translate-y-0.5
            active:translate-y-0
            flex items-center gap-2
          `}
        >
          <span className="flex items-center gap-1.5">
            <span>{label || getDefaultLabel()}</span>
            <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" />
          </span>
        </button>
      </Link>
    </div>
  );
};

export default ViewAllButton;
